import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import TypesIndicateurs from './Indicateurs/TypesIndicateurs';
import AffectationsIndicateurs from './Indicateurs/AffectationsIndicateurs';
import NbReclamationsEmisesIndicateur from './Indicateurs/NbReclamationsEmisesIndicateur';
import NbReclamationsAffecteesIndicateur from './Indicateurs/NbReclamationsAffecteesIndicateur';
import NbReclamationsObservateurIndicateur from './Indicateurs/NbReclamationsObservateurIndicateur';
import NbCommentairesIndicateur from './Indicateurs/NbCommentairesIndicateur';
import NbReclamationsCreeesIndicateur from './Indicateurs/NbReclamationsCreeesIndicateur';
import NbReclamationsClotureesIndicateur from './Indicateurs/NbReclamationsClotureesIndicateur';

const styles = {
    root: {
        padding: '20px',
        paddingTop: '28px'
    }
};



class DashboardPage extends React.Component {

    render() {
        let { classes } = this.props;

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        if (!utilisateurCourant) {
            return null;
        }
        
        let adminOuPilote = utilisateurCourant.groupes.find(groupe => groupe.adminOuPilote) !== undefined;


        return (
            <div className={classes.root}>
                <Helmet>
                    <title>Tableau de bord</title>
                </Helmet>
                <Grid container spacing={3} alignItems='stretch'>
                    <Grid item xs>
                        <NbReclamationsEmisesIndicateur />
                    </Grid>
                    <Grid item xs>
                        <NbReclamationsAffecteesIndicateur />
                    </Grid>
                    <Grid item xs>
                        <NbReclamationsObservateurIndicateur />
                    </Grid>
                    <Grid item xs>
                        <NbCommentairesIndicateur />
                    </Grid>
                    <Grid item xs>
                        <NbReclamationsCreeesIndicateur />
                    </Grid>
                    <Grid item xs>
                        <NbReclamationsClotureesIndicateur />
                    </Grid>

                    <TypesIndicateurs />

                    {adminOuPilote && <AffectationsIndicateurs />}
                    
                </Grid>
            </div>
        );
    }
}


DashboardPage.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DashboardPage);